export default function isCoreLanguage(language) {
  return ['en', 'es', 'pt', 'de', 'fr', 'it', 'ru', 'zh', 'ja', 'ko'].includes(language)
}
